import React, { useState } from "react";
import  "../../assets/css/components/buttons.css";
import { Row, Col, Image } from "react-bootstrap";
const CustomButton = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const { text,type } = props;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <button  onClick={props.onClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={`btn-theme-2 btn-theme-${type} ${isHovered && `btn-theme-${type}-hover`}`}>

      {text}
    </button>
  );
};

export default CustomButton;
